import React from 'react';

import { Avatar, Box, Tooltip, Typography } from 'components';

import { styled, useSelector } from 'third-party';

import { appSelectors } from 'selectors';

import { getOrganizationAvatarUrl } from 'utils/app';

import { APIOrganization } from 'types/api';

const AvatarWrapper = styled(Box)<{ $isCollapsed: boolean }>`
  position: relative;
  width: ${props => (props.$isCollapsed ? '2rem' : '4rem')};
  height: ${props => (props.$isCollapsed ? '2rem' : '4rem')};
  transition: width 0.3s ease-in-out, height 0.3s ease-in-out;
`;

const SandboxBadge = styled.div<{ $isCollapsed: boolean }>`
  position: absolute;
  bottom: -2px;
  left: 50%;
  transform: translateX(-50%);
  background: ${props => props.theme.custom.palette.warning600};
  color: #ffffff;
  font-size: ${props => (props.$isCollapsed ? '5px' : '6.5px')};
  font-weight: 800;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  padding: ${props => (props.$isCollapsed ? '2px 5px' : '2px 7px')};
  border-radius: 20px;
  white-space: nowrap;
  text-align: center;
  line-height: 1;
  box-shadow: 0 1px 5px rgba(234, 88, 12, 0.45);
  pointer-events: none;
  z-index: 2;
  border: 1.5px solid rgba(255, 255, 255, 0.25);
`;

export const OrganizationMenuHeader = (organization: APIOrganization) => {
  const isNavigationCollapsed = useSelector(appSelectors.isNavigationCollapsed);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding="0.3rem 0 0.3rem 0"
    >
      <Tooltip title={organization.name} placement="right" arrow>
        <AvatarWrapper $isCollapsed={isNavigationCollapsed}>
          {organization.isSandbox && (
            <SandboxBadge $isCollapsed={isNavigationCollapsed}>
              SANDBOX
            </SandboxBadge>
          )}
          <Avatar
            src={getOrganizationAvatarUrl(organization)}
            sx={{
              width: '100%',
              height: '100%',
            }}
          />
        </AvatarWrapper>
      </Tooltip>
      <Box
        sx={{
          // Clears the avatar, and the SANDBOX badge that overhangs its bottom edge.
          // Collapses away entirely when the name itself is hidden.
          marginTop: isNavigationCollapsed ? 0 : '0.5rem',
          height: isNavigationCollapsed ? 0 : '1.75rem',
          width: '90%',
          overflow: 'hidden',
          transition: 'height 0.3s ease-in-out, margin-top 0.3s ease-in-out',
        }}
      >
        <Typography
          variant="subtitle1"
          align="center"
          sx={{
            color: theme => theme.palette.primary.light,
            fontWeight: 600,
            width: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            opacity: isNavigationCollapsed ? 0 : 1,
            transition: 'opacity 0.2s ease',
            visibility: isNavigationCollapsed ? 'hidden' : 'visible',
          }}
        >
          {organization.name}
        </Typography>
      </Box>
    </Box>
  );
};
